<div id="container">
  <p id="header">{{ 'INCOMPATIBLE_ACTIVATIONS' | translate }}</p>

  <div class="alert alert-warning" role="alert">
    <i class="fa fa-exclamation-triangle mr-2"></i>
    {{ 'DEVICE_REPLACE_INCOMPATIBLE_ACTIVATIONS_INFO' | translate }}
    <ul class="mb-0 mt-2">
      @for (route of data.affectedRoutes; track route) {
        <li>
          <strong>{{ route.routeName }}</strong>
          <ul class="mb-0">
            @for (activation of route.activationNames; track activation) {
              <li>{{ activation }}</li>
            }
          </ul>
        </li>
      }
    </ul>
  </div>

  <button type="button" class="btn btn-primary ml-2" (click)="proceed()">
    {{ 'CONFIRM' | translate }}
  </button>

  <button type="button" class="btn secondaryBtnWhiteBg ml-2" (click)="cancel()">
    {{ 'CANCEL' | translate }}
  </button>
</div>
